export const paymentErrors = {
  riskThreshold: 'Risk threshold exceeded. This might be caused by too many payment attempts happening in a short time period',
  threeDSecure: 'The 3D Secure challenge failed; this is the extra authentication step from your bank that should have appeared',
};
